import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { NestData } from "../nesting-summary-cards/nesting-summary-cards";

@Component({
  selector: "app-nesting-summary",
  templateUrl: "./nesting-summary.component.html",
  styleUrls: ["./nesting-summary.component.scss"],
  standalone: false,
})
export class NestingSummary implements OnChanges {
  @Input() nestingSummaryData: NestData[] = [];
  @Input() showLoader?: boolean = false;
  readonly displayOrder = ["more-than-5", "5", "4", "3", "2", "1"];

  readonly displayLabelMap: { [key: string]: string } = {
    "more-than-5": "More than 5 SKU Nests",
    "5": "5 SKU Nest",
    "4": "4 SKU Nest",
    "3": "3 SKU Nest",
    "2": "2 SKU Nest",
    "1": "1 SKU Nest",
  };

  displayData: {
    key: string;
    label: string;
    nests: number;
    percent: number;
  }[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["nestingSummaryData"]) {
      this.prepareDisplayData();
    }
  }

  private normalizeKey(s: string): string {
    if (!s) {
      return "";
    }
    const t = s.trim().toLowerCase();
    if (
      t.includes("more") ||
      t.includes("more than") ||
      t.includes(">") ||
      t.includes("5 skus")
    ) {
      return "more-than-5";
    }
    const match = t.match(/^\s*(\d+)/);
    if (match) {
      return match[1];
    }
    if (t.includes("5")) {
      return "5";
    }
    return t;
  }

  private prepareDisplayData(): void {
    const total =
      this.nestingSummaryData?.reduce(
        (sum, d) => sum + (d.count_of_nests || 0),
        0,
      ) || 0;
    const map = new Map<string, NestData>();
    (this.nestingSummaryData || []).forEach((d) => {
      const key = this.normalizeKey(d.count_of_Skus);
      const existing = map.get(key);
      if (existing) {
        existing.count_of_nests =
          (existing.count_of_nests || 0) + (d.count_of_nests || 0);
      } else {
        map.set(key, { ...d });
      }
    });

    this.displayData = this.displayOrder.map((key) => {
      const entry = map.get(key);
      const nests = entry ? entry.count_of_nests || 0 : 0;
      const providedPct =
        entry && typeof entry["%Count"] === "number"
          ? entry["%Count"]
          : undefined;
      const percent =
        typeof providedPct === "number"
          ? providedPct
          : total > 0
            ? (nests / total) * 100
            : 0;

      return {
        key,
        label: this.displayLabelMap[key] || key,
        nests,
        percent,
      };
    });
  }

  formatPercent(p: number): string {
    return `${p.toFixed(2)}%`;
  }
}
